import { createModel } from '@/store/tools';

const model = {
    namespace: 'searchhelp',
    build: (T, A, S, R) => ({
        actiontypes: {
            // 商户须知
            'getQuestionList': T('getQuestionList'),
            'getSearchList': T('getSearchList'),

            // 促销推广
            'getTitleList': T('getTitleList'),

            // 详情
            'getDetail': T('getDetail'),
        },
        actions: {
            'getQuestionList': A('getQuestionList'),
            'getSearchList': A('getSearchList'),
            'getTitleList': A('getTitleList'),
            'getDetail': A('getDetail'),
        },
        sagas: {
            'getQuestionList': S('getQuestionList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.listOperationCompanyStrategyClass'),
            'getSearchList': S('getSearchList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.listSerchStrategyInfo'),
            'getTitleList': S('getTitleList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.listOperationCompanyStrategyInfo'),
            'getDetail': S('getDetail', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.getStrategyInfo'),
        },
        reducers: {
            'questionList': R('getQuestionList', []),
            'searchList': R('getSearchList', []),
            'titleList': R('getTitleList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'detail': R('getDetail', {}),
        }
    })
};
export default createModel(model);